/* eslint-disable */
const fr = {
  common: {
    entity: "Quantum Capital Management S.A.",
    entity_short: "QUANTUM",
    city: "Luxembourg",
    email: "office@qcmlux.com"
  },
  hero: {
    scroll: "Défiler"
  },
  hero_cinematic: {
    home: {
      eyebrow: "Quantum Capital Management",
      title: "GFIA luxembourgeois",
      subtitle: "Gestion de fonds d'investissement alternatifs",
      alt: "Quartier financier de Kirchberg à l'heure bleue"
    },
    services: {
      eyebrow: "Services",
      title: "Services",
      subtitle: "Gestion institutionnelle d'investissement",
      alt: "Architecture froide et bleutée du quartier financier luxembourgeois à l'heure bleue"
    },
    legal: {
      eyebrow: "Mentions légales",
      title: "Mentions légales",
      subtitle: "Informations légales et réglementaires",
      alt: "Intérieur institutionnel européen — colonnade de marbre dans une teinte bleu-gris froide"
    },
    contact: {
      eyebrow: "Contact",
      title: "Contact",
      subtitle: "Siège social et demandes",
      alt: "Dirigeante institutionnelle surplombant un quartier financier européen à l'aube"
    }
  },
  menu: {
    open: "Menu",
    close: "Fermer",
    navigate: "Naviguer",
    language: "Langue",
    lang_note: "Le site est en cours de traduction. Des versions préliminaires en français et en allemand sont disponibles pour revue.",
    entity: "Quantum Capital Management S.A.",
    nav: {
      home: "Accueil",
      services: "Services",
      legal: "Mentions légales",
      contact: "Contact"
    }
  },
  home: {
    eyebrow: "Luxembourg",
    h1_l1: "Quantum Capital",
    h1_l2: "Management S.A.",
    hero_sub: "Gestionnaire de fonds d'investissement alternatifs luxembourgeois",
    reg_eyebrow: "Statut réglementaire",
    reg_body: "Quantum Capital Management S.A. est un gestionnaire de fonds d'investissement alternatifs (GFIA) établi au Luxembourg, au service de structures d'investissement institutionnelles à travers la gouvernance, la gestion de portefeuille, la gestion des risques et la supervision réglementaire.",
    services_eyebrow: "Services",
    services_h2: "Gouvernance, gestion de portefeuille, gestion des risques et supervision réglementaire.",
    framework_eyebrow: "Cadre institutionnel",
    framework_body: "L'architecture réglementaire luxembourgeoise — ancrée dans la loi du 12 juillet 2013 et la Directive 2011/61/UE — offre l'un des cadres européens les plus établis pour la gestion de fonds d'investissement alternatifs. La Société opère au sein de ce régime sous la supervision continue de la CSSF, dans l'intérêt des investisseurs et des structures qu'elle sert.",
    framework_image_alt: "Long couloir institutionnel européen — parquet en chêne et hautes fenêtres",
    close_image_alt: "Toits de la Vieille Ville de Luxembourg à l'heure bleue",
    mid_alt: "Détail architectural — colonne de marbre au liseré de laiton dans la lumière du matin",
    bluehour_alt: "Toits de la Vieille Ville de Luxembourg à l'heure bleue",
    footprint_eyebrow: "Empreinte internationale",
    footprint_h2: "Une base luxembourgeoise reliée à des contreparties institutionnelles à travers le monde.",
    footprint_body: "Depuis sa base réglementée au Luxembourg, la Société travaille aux côtés d'investisseurs institutionnels, de fonds, de prestataires de services et d'autorités de régulation dans un ensemble défini de juridictions.",
    footprint_map_alt: "Carte du monde indiquant le Luxembourg, la France, l'Allemagne, les États-Unis, la Chine, le Qatar et les Émirats arabes unis.",
    footprint_caption: "Illustratif — juridictions des relations institutionnelles",
    footprint_countries: {
      united_states: "États-Unis",
      luxembourg: "Luxembourg",
      france: "France",
      germany: "Allemagne",
      china: "Chine",
      qatar: "Qatar",
      uae: "Émirats arabes unis"
    }
  },
  contact_map: {
    eyebrow: "Présence",
    heading: "Où nous intervenons",
    subtitle: "La Société entretient des relations institutionnelles dans les principales places financières.",
    map_alt: "Carte du monde indiquant le Luxembourg, Francfort, Zurich, Paris, Doha, Dubaï et Shanghai.",
    caption: "Illustratif — principales juridictions d'activité",
    countries: {
      luxembourg: "Luxembourg",
      germany: "Allemagne",
      switzerland: "Suisse",
      france: "France",
      qatar: "Qatar",
      uae: "Émirats arabes unis",
      china: "Chine"
    }
  },
  services_cards: {
    aifm: {
      eyebrow: "01 / Gestion de fonds",
      title: "Gestion de fonds d'investissement alternatifs",
      line: "Gestion de structures d'investissement alternatives conformément à la loi luxembourgeoise sur les GFIA et à la Directive 2011/61/UE.",
      image_alt: "Façade en verre moderne et abstraite dans la lumière douce du matin"
    },
    portfolio: {
      eyebrow: "02 / Portefeuille",
      title: "Gestion de portefeuille",
      line: "Supervision disciplinée alignée sur la politique d'investissement de chaque fonds et sur les responsabilités fiduciaires.",
      image_alt: "Détail d'intérieur institutionnel — bureau et ouvrages reliés en cuir"
    },
    risk: {
      eyebrow: "03 / Risques",
      title: "Gestion des risques",
      line: "Cadre indépendant couvrant les risques de marché, de liquidité, de contrepartie et opérationnels.",
      image_alt: "Étude architecturale — colonnade aux formes de pierre répétées"
    },
    governance: {
      eyebrow: "04 / Gouvernance",
      title: "Gouvernance et supervision réglementaire",
      line: "Gouvernance d'entreprise, reporting CSSF, conformité et supervision des délégations.",
      image_alt: "Long couloir institutionnel au sol de calcaire clair"
    }
  },
  services_page: {
    eyebrow: "Services",
    h1: "Services",
    intro: "Gestion réglementaire, supervision de portefeuille, gestion des risques et gouvernance pour les structures d'investissement alternatives luxembourgeoises.",
    hero_alt: "Intérieur institutionnel européen minimaliste et paisible",
    detail_alt: "Couloir intérieur institutionnel — sol en marbre et boiseries",
    sections: {
      aifm: {
        number: "01",
        title: "Gestion de fonds d'investissement alternatifs",
        body: "Gestion de structures d'investissement alternatives conformément à la réglementation luxembourgeoise applicable, en particulier la loi luxembourgeoise du 12 juillet 2013 relative aux gestionnaires de fonds d'investissement alternatifs et à la Directive 2011/61/UE (Directive AIFM)."
      },
      portfolio: {
        number: "02",
        title: "Gestion de portefeuille",
        body: "Supervision de portefeuille disciplinée, alignée sur les objectifs d'investissement de chaque fonds, sa politique d'investissement et les responsabilités fiduciaires, exercée dans l'intérêt des investisseurs."
      },
      risk: {
        number: "03",
        title: "Gestion des risques",
        body: "Cadre indépendant de gestion des risques couvrant les risques de marché, de liquidité, de contrepartie et opérationnels, en cohérence avec les exigences de la Directive AIFM."
      },
      governance: {
        number: "04",
        title: "Gouvernance et supervision réglementaire",
        body: "Gouvernance d'entreprise, reporting réglementaire auprès de la CSSF, supervision de la conformité, suivi des délégations et supervision opérationnelle des activités de la société de gestion."
      }
    }
  },
  contact: {
    eyebrow: "Contact",
    h1: "Contact",
    intro: "Pour toute demande professionnelle et institutionnelle.",
    header_alt: "Salle de conseil européenne raffinée dans la lumière du jour",
    office_heading: "Siège social",
    office_address_line1: "1 Haaptstrooss",
    office_address_line2: "L-9806 Hosingen, Luxembourg",
    office_address_placeholder: "1 Haaptstrooss, L-9806 Hosingen, Luxembourg",
    labels: {
      rcs: "RCS Luxembourg",
      rcs_value: "B215925",
      lei: "LEI",
      lei_value: "984500BA00891BF49F35",
      email: "Courriel",
      telephone: "Téléphone",
      placeholder: "[Espace réservé]"
    },
    form: {
      contacting_as: "Je contacte en qualité de",
      first_name: "Prénom",
      last_name: "Nom",
      organisation: "Organisation",
      email: "Courriel professionnel",
      country: "Pays",
      subject: "Objet",
      message: "Message",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      select_prompt: "Sélectionner…",
      required_star: "*",
      char_count: "{count} / 5000",
      consent_prefix: "J'ai pris connaissance de la ",
      consent_link: "Politique de confidentialité",
      consent_suffix: " et je consens au traitement de mes données personnelles aux fins de la réponse à ma demande.",
      errors: {
        required: "Champ requis.",
        category: "Veuillez sélectionner une catégorie.",
        email: "Veuillez saisir une adresse électronique valide.",
        message_min: "Veuillez saisir au moins 20 caractères.",
        message_max: "Maximum 5000 caractères.",
        consent: "Le consentement est requis pour soumettre ce formulaire.",
        rate_limit: "Trop de soumissions depuis cet emplacement. Veuillez réessayer plus tard.",
        generic: "Votre demande n'a pas pu être envoyée. Veuillez réessayer.",
        network: "Une erreur réseau est survenue. Veuillez réessayer."
      },
      categories: {
        institutional_investor: "Investisseur institutionnel",
        investment_fund: "Fonds d'investissement",
        regulator: "Autorité de régulation",
        service_provider: "Prestataire de services",
        business_partner: "Partenaire",
        general_enquiry: "Demande générale"
      },
      helper: {
        regulator: "La correspondance réglementaire sera transmise à la fonction compétente."
      }
    },
    success: {
      title: "Merci.",
      body: "Votre demande a bien été reçue. Un membre de l'équipe vous répondra prochainement.",
      reset: "Envoyer une autre demande"
    }
  },
  legal: {
    eyebrow: "Mentions légales",
    h1: "Informations légales et réglementaires",
    last_updated_label: "Dernière mise à jour",
    toc_label: "Sommaire",
    toc_mobile_label: "Sommaire",
    section_titles: {
      "legal-notice": "Mentions légales",
      "regulatory-information": "Informations réglementaires",
      "privacy": "Politique de confidentialité",
      "cookies": "Politique de cookies",
      "complaints": "Traitement des réclamations",
      "conflicts": "Conflits d'intérêts",
      "remuneration": "Politique de rémunération",
      "sfdr": "Durabilité (SFDR)",
      "disclaimer": "Avertissement"
    }
  },
  footer: {
    tagline: "Gestionnaire de fonds d'investissement alternatifs luxembourgeois",
    links: {
      legal_notice: "Mentions légales",
      privacy: "Politique de confidentialité",
      cookies: "Politique de cookies",
      contact: "Contact"
    },
    group_line: "Membre du groupe Quantum",
    copyright: "© {year} Quantum Capital Management S.A. · Luxembourg"
  },
  cookie: {
    copy_prefix: "Ce site utilise uniquement des cookies essentiels au fonctionnement du site. Pour plus d'informations, veuillez consulter notre ",
    policy_link: "Politique de cookies",
    copy_suffix: ".",
    dismiss: "Accepter"
  },
  draft: {
    text: "Cette version française est une traduction préliminaire, en attente de revue juridique."
  }
};
export default fr;
